import React, { useState } from "react";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE || "";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", msg: "" });
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setStatus({ type: "error", msg: data?.message || "Chyba požadavku." });
      } else {
        setStatus({
          type: "success",
          msg:
            data?.message ||
            "Pokud účet existuje, odkaz pro obnovu hesla byl zaslán.",
        });
      }
    } catch (err) {
      setStatus({ type: "error", msg: "Chyba připojení k serveru." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-50">
      <div className="w-full max-w-md bg-white border rounded-2xl shadow p-6">
        <h1 className="text-2xl font-extrabold text-gray-900 mb-2">Obnova hesla</h1>
        <p className="text-gray-600 mb-6">
          Zadejte e-mail. Pokud účet existuje, bude na email zaslán odkaz pro nastavení nového hesla.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              className="w-full rounded-xl border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
              placeholder="např. mesto.ulice@lekarnalemon.cz"
            />
          </div>

          {status.msg && (
            <div
              className={`rounded-xl px-3 py-2 text-sm ${
                status.type === "success"
                  ? "bg-green-50 text-green-800 border border-green-200"
                  : "bg-red-50 text-red-800 border border-red-200"
              }`}
            >
              {status.msg}
            </div>
          )}

          <button
            disabled={loading}
            className="w-full rounded-xl bg-blue-700 text-white font-semibold py-2 hover:bg-blue-800 disabled:opacity-60"
          >
            {loading ? "Odesílám..." : "Odeslat odkaz"}
          </button>
        </form>

        <div className="mt-4 text-sm text-gray-600">
          <Link to="/login" className="text-blue-700 hover:underline">
            Zpět na přihlášení
          </Link>
        </div>
      </div>
    </div>
  );
}